// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Y84x","header":"MergedInvoice_header__27z7i"};